<template>
  <v-theme-provider dark>
    <base-section id="social" class="amber darken-3 text-center" space="56">
      <base-icon class="mb-8">
        mdi-facebook
      </base-icon>

      <base-section-heading color="transparent" title="Social Media">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua
      </base-section-heading>

      <div class="py-4" />

      <v-btn
        class="font-weight-bold"
        color="white"
        href="https://www.facebook.com/"
        light
        min-width="168"
        target="_blank"
        x-large
      >
        Follow Us

        <v-icon right>
          mdi-facebook
        </v-icon>
      </v-btn>
      &nbsp; &nbsp;
      <v-btn
        class="font-weight-bold"
        color="white"
        href="https://www.linkedin.com/"
        light
        min-width="168"
        target="_blank"
        x-large
      >
        Follow Us

        <v-icon right>
          mdi-linkedin
        </v-icon>
      </v-btn>
    </base-section>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SectionNews",

  provide: {
    heading: { align: "center" }
  }
};
</script>
